import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticleList() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-500/20 text-primary-400">
            <i className="ri-article-line"></i>
          </div>
          <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-50">
            影视资讯
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {articles.slice(0, 6).map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group rounded-xl overflow-hidden bg-background-900/60 border border-background-800/50 hover:border-primary-500/30 hover:bg-background-800/60 transition-all duration-300 cursor-pointer"
          >
            <div className="relative h-44 md:h-48 overflow-hidden">
              <img
                src={article.coverImage}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2.5 py-1 rounded-md text-xs font-medium bg-primary-500/80 text-background-950">
                  {article.tags[0]}
                </span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-2 mb-2">
                {article.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-400 line-clamp-2 mb-3 leading-relaxed">
                {article.summary}
              </p>
              <div className="flex items-center justify-between text-xs text-foreground-500">
                <span>{article.publishDate}</span>
                <div className="flex items-center gap-3">
                  <span className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-eye-line text-[10px]"></i>
                    </div>
                    {article.views > 10000
                      ? `${(article.views / 10000).toFixed(1)}万`
                      : article.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-thumb-up-line text-[10px]"></i>
                    </div>
                    {article.likes}
                  </span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}